import i18n from "i18next";

export { i18n };
export { T } from "./t";
export { useTranslation } from "react-i18next";
export {
  ALL_LOCALES,
  DEFAULT_LOCALE,
  getLocaleName,
  localeMatchesSearch,
  searchLocales,
} from "./locales";
export type { Locale } from "./locales";
export { LocalizationProvider } from "./localization-provider";
export { ScopedLocaleProvider } from "./scoped-locale-provider";
export { ALL_PLURAL_SUFFIXES, getPluralForms } from "./plurals";
export type { PluralSuffix } from "./plurals";
export { parseI18nKeyMetadata } from "./key-metadata";
export type { ParsedI18nKey } from "./key-metadata";
export type { I18nBundle } from "./resources";

/**
 * English catalog keys are the source message. i18next's `t` returns
 * undefined until `initI18n`, which breaks module-scope labels in tests.
 */
function englishSource(
  key: string,
  options?: Record<string, unknown>,
): string {
  if (!options) {
    return key;
  }
  return key.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (match, name: string) => {
    const value = options[name];
    if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      return String(value);
    }
    return match;
  });
}

export function t(
  key: string,
  options?: Record<string, unknown>,
): string {
  if (!i18n.isInitialized) {
    return englishSource(key, options);
  }
  return i18n.t(key, options);
}

/** Active UI language, for locale-aware formatting outside React. */
export function getLanguage(): string | undefined {
  return i18n.language;
}

/** Accepts the hook's `t` and the module-level one above. */
export type Translate = (
  key: string,
  options?: Record<string, unknown>,
) => string;
